import classNames from 'classnames';
import type { SnapshotLicenseUsageValue } from 'pages/SnapshotManagement/toSnapshotLicenseUsage';
import type { FC, ReactNode } from 'react';
import { licenseSectionClassName } from './LicenseSectionsGrid';

export type OnPremLicenseSectionProps = {
  onPremise: SnapshotLicenseUsageValue['onPremise'];
  /** The device type breakdown, or its loading / error state. */
  children: ReactNode;
  className?: string;
};

/** On-premise device licenses: consumption summary plus the device type breakdown below it. */
export const OnPremLicenseSection: FC<OnPremLicenseSectionProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames(licenseSectionClassName, className)}>
      <div className='flex flex-col gap-xs'>
        <h2 className='m-none font-semibold text-default text-level-5'>
          On-prem
        </h2>
      </div>
      {children}
    </div>
  );
};
